import { render, staticRenderFns } from "./Resource-table.vue?vue&type=template&id=1cd84b39"
import script from "./Resource-table.vue?vue&type=script&lang=js"
export * from "./Resource-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports